import debug from "debug";
const log = debug("validate-form");

class ValidateForm {
	constructor(element, options) {
		log("element", element);
		log("options", options);

		this.options = options;
		this.form = element;		

		this.formElements = [...this.form.querySelectorAll("input,select,fieldset[data-required]")];

		// Elements that may have error messages to display
		this.componentErrorCollection = [
			...this.form.querySelectorAll(this.options.componentErrorSelector)
		];
		
		this.watch();

		log("ready", this, this.form);
	}	

	watch() {
		log("watching");		
		this.form.addEventListener("submit", this.onFormSubmit.bind(this));
	}



	isInvalid() {
		return this.formElements
			.map(element => {

				//	data-required used as a proxy for required property on validated fieldset elements
				if (element.dataset.required === 'true') {
					return element.validity.valid;
				}
				if (element.dataset.required === 'false') {
					return true;
				}

				return element.validity.valid;
			})
			.includes(false);
	}

	showErrors() {
		this.componentErrorCollection.forEach(component => {
			component.dataset.showErrors = true;
		});
	}

	onFormSubmit(event) {
		if (this.isInvalid()) {
			event.preventDefault();
			this.showErrors();
		} 
	}	
}

ValidateForm.DEFAULTS = {
	componentErrorSelector: "[data-show-errors]"
};

export default ValidateForm;



// WEBPACK FOOTER //
// ./project/client/src/core/modules/cover-selector/components/validate-form/validate-form.js